import React from "react";
import ReactPlayer from "react-player";
import TextS1st2911 from "../text/TextS1st2911";

const headlineStyle = {
  marginLeft:'10px',
  marginRight:'10px',
  fontWeight:'600',
  color:'var(--black)',
  textTransform:'uppercase'
}

const VideoPlayer = () => {
  return (
    <>
      <TextS1st2911 data={{ text: "LIVE VIDEO", customStyle: headlineStyle }} />
      <div className="player-wrapper">
        <ReactPlayer
          className="react-player"
          url="https://www.youtube.com/watch?v=LlvBzyy-558"
          width="100%"
          height="100%"
          controls={true}
          config={{
            playerOptions: {
              playsinline: true,
            },
          }}
        />
      </div>
    </>
  );
};
export default VideoPlayer;
